import React, { useEffect } from "react";
import { useToken } from "@rentablo/api";
import { useMandatorContext } from "@rentablo/theming";
import { goToSessionLogout } from "@helpers/mainAppUrls";
import { LoadingProgressBar } from "@rentablo/components";
import { useNavigate } from "react-router";
import { useFirebaseOidcClient } from "../loginSSO/hooks/useFirebaseOidcClient";
import {
  getLoginPathForMandator,
  showSSOForMandator,
} from "../mandatorLoginConfig";

export const LogoutWithRedirect = () => {
  const { logout } = useToken({ enabled: false });
  const { mandatorSlug } = useMandatorContext();
  const usesSso = showSSOForMandator(mandatorSlug);
  const { signOut } = useFirebaseOidcClient({ enabled: usesSso });
  const navigate = useNavigate();

  useEffect(() => {
    void (async () => {
      const loginPathAfterLogout = getLoginPathForMandator(mandatorSlug);

      logout();

      try {
        if (usesSso) {
          await signOut();
        }
      } finally {
        if (loginPathAfterLogout) {
          navigate(loginPathAfterLogout);
        } else if (import.meta.env.VITE_APP_NAME === "rentablo") {
          goToSessionLogout();
        } else {
          window.location.href = import.meta.env.VITE_APP_ROOT_URL!;
        }
      }
    })();
  }, [mandatorSlug, usesSso, logout, signOut, navigate]);

  return <LoadingProgressBar />;
};
